<template>
  <section class="page-wrapper">
    <page-header
      v-if="title"
      :title="title"
      :is-job-list-page="isJobListPage"
      :is-invoice-list-page="isInvoiceListPage"
      :show-filter-result="showFilterResult"
      class="page-header"
      @showMobileNavBar="showMobileNavBar"
      @showMobileFilter="showMobileFilter"
    ></page-header>
    <slot name="header"></slot>
    <main :class="pageContentClass">
      <slot></slot>
    </main>
  </section>
</template>

<script>
import PageHeader from "./SupplierPageHeader"

export default {
  components: {
    PageHeader,
  },
  props: {
    title: {
      type: null,
      default: undefined,
    },
    noPadBtm: {
      type: null,
      default: undefined,
    },
    isJobListPage: {
      type: null,
      default: undefined,
    },
    isInvoiceListPage: {
      type: null,
      default: undefined,
    },
    showFilterResult: {
      type: null,
      default: undefined,
    },
  },
  computed: {
    pageContentClass() {
      return {
        "page-content": true,
        "no-pad-btm": this.noPadBtm ? this.noPadBtm : false,
      }
    },
  },
  methods: {
    showMobileNavBar() {
      this.$emit("showMobileNavBar")
    },
    showMobileFilter() {
      this.$emit("showMobileFilter")
    },
  },
}
</script>

<style lang="scss" scoped>
.page-wrapper {
  display: flex;
  flex-flow: column nowrap;

  flex-grow: 1;
  max-width: 100%;
}

.page-header {
  position: sticky;
  flex-shrink: 0;
}

.page-content {
  overflow-y: auto;
  flex-grow: 1;
  padding-bottom: 60px;
  background-color: white;

  &.no-pad-btm {
    padding-bottom: 0px;
  }
}
</style>
